import type { StorageManager } from '@/storage/save-data';
import type { LevelData } from '@/game/level';
import type { Verifier } from './sync-types';

export interface DownloadedCache {
  verifier: Verifier | null;
  currentVersionCompletionCount: number;
  cachedAt: number;
}

export class DownloadedRepo {
  constructor(private sm: StorageManager) {}

  list(): LevelData[] {
    return this.sm.getDownloadedLevels();
  }

  has(remoteId: string): boolean {
    return this.list().some((l) => l.meta.remoteId === remoteId);
  }

  save(level: LevelData): void {
    this.sm.upsertDownloadedLevel(level);
  }

  remove(remoteId: string): void {
    this.sm.removeDownloadedLevel(remoteId);
  }

  getCache(remoteId: string): DownloadedCache | null {
    return this.sm.getDownloadedLevelCache(remoteId);
  }

  updateCache(remoteId: string, cache: DownloadedCache): void {
    this.sm.setDownloadedLevelCache(remoteId, cache);
  }
}
